
import { RuleObject , FormInstance } from 'antd/es/form';

export const requiredIfUtmOrigin = (form: FormInstance) => {
  return (_: RuleObject, value: string): Promise<void> => {
    const utmOrigin: number = form.getFieldValue('utm_origin');
    if ((utmOrigin === 2 || utmOrigin === 3) && (!value || value.trim() === '')) {
      return Promise.reject(new Error('Обязательное заполнение'));
    }
    return Promise.resolve();
  };
};
